import { render, staticRenderFns } from "./SetVendorPassword.vue?vue&type=template&id=928fc1ce&scoped=true"
import script from "./SetVendorPassword.vue?vue&type=script&lang=js"
export * from "./SetVendorPassword.vue?vue&type=script&lang=js"
import style0 from "./SetVendorPassword.vue?vue&type=style&index=0&id=928fc1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928fc1ce",
  null
  
)

export default component.exports